import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {CardImagesmaster} from "../models/card_imagesmaster";
import {CardImagesService} from "../services/card_images.service";
import {ActivatedRoute, Router} from "@angular/router";
declare var $: any;

@Component({
    selector: 'app-addcard_images',
    templateUrl: './addcard_images.component.html'
})
export class AddcardImagesComponent implements OnInit {
    title:string = "Add Card Image";
    card_images_id = 0;
    cardimageform: FormGroup;
    cardimageinfo: CardImagesmaster;
    card_id: number = 0;
    public allcategories = [];
    public selectedValue;
    public catvalue;
    public pages = [];
    isEdit: boolean = false;
    ckeditorContent;
    constructor(
        private cardImagesService:CardImagesService,
        private router: Router,
        private fb: FormBuilder,
        private activatedRoute: ActivatedRoute,
    ) {
        activatedRoute.params.subscribe(params => {
            this.card_images_id = params["id"];
            if(params['cardid']) {
                this.card_id = params['cardid'];
                console.log("CardId======>",this.card_id); // Print the parameter to the console.
            }
        });
        if(this.card_images_id > 0){
            this.isEdit = true;
        }
        if(this.card_images_id > 0){
            this.title = "Edit Card Image";
        }
    }

    ngOnInit() {
        this.title;
        this.isEdit;
        this.cardimageform = this.fb.group({
            x: ['',
                Validators.required
            ],
            card_id: [],
            height: ['',
                Validators.required
            ],
            y: ['',
                Validators.required
            ],
            width: ['',
                Validators.required
            ],
        });

        if (this.isEdit) {
            this.getCardImageInfo();
        } else {
            this.cardimageform.patchValue({
                card_id: this.card_id,
            })
    
        }
        
        //this.loadScriptLibrary();
    }

    onSubmit(cardValue) {
        
        if(this.isEdit){
            this.updateForm(cardValue);
        }else{
            this.addForm(cardValue);
        }
    }

    addForm(cardImagesValue){
        $('#save_card').button('loading');
        this.cardImagesService.createCardImage(cardImagesValue).then(CardImageData => {
            if(CardImageData['code'] === 200){
                $('#save_card').button('reset');
                $.toast({heading: 'Success', text: CardImageData['message'], position: 'top-right', showHideTransition: 'slide', icon: 'success'});
                this.router.navigate(['/cards/cardimages/'+cardImagesValue['card_id']]);
            }else{
                $.toast({heading: 'Warning', text: CardImageData['message'], position: 'top-right', showHideTransition: 'slide', icon: 'warning'});
                $('#save_card').button('reset');
            }
        }).catch(err => {
            if(err['code'] != 200){
                $.toast({heading: 'Error', text: err['message'], position: 'top-right', showHideTransition: 'slide', icon: 'error'});
            }else{
                $.toast({heading: 'Error', text: 'Server error! Please try again later', position: 'top-right', showHideTransition: 'slide', icon: 'error'});
            }
            $('#save_card').button('reset');
        });
    }

    updateForm(cardImagesValue){
        $('#update_card').button('loading');
        cardImagesValue['card_images_id'] = this.card_images_id;
        this.cardImagesService.updateCardImage(cardImagesValue).then(CardImageData => {
            if(CardImageData['code'] === 200){
                $('#update_card').button('reset');
                $.toast({heading: 'Success', text: CardImageData['message'], position: 'top-right', showHideTransition: 'slide', icon: 'success'});
                this.router.navigate(['/cards/cardimages/'+cardImagesValue['card_id']]);
            }else{
                console.log(CardImageData['message']);
                $.toast({heading: 'Warning', text: CardImageData['message'], position: 'top-right', showHideTransition: 'slide', icon: 'warning'});
                $('#update_card').button('reset');
            }
        }).catch(err => {
            if(err['status'] != 200){
                $.toast({heading: 'Error', text: err['message'], position: 'top-right', showHideTransition: 'slide', icon: 'error'});
            }else{
                $.toast({heading: 'Error', text: 'Server error! Please try again later', position: 'top-right', showHideTransition: 'slide', icon: 'error'});
            }
            $('#update_card').button('reset');
        });
    }

    getCardImageInfo=function () {
        this.cardImagesService.getCardImageInfo(this.card_images_id).then(data => {
            console.log("CardImageInfo11=======>",data['data']);
            this.cardimageinfo = data['data'];
            this.patchForm();
        });
       

    }

    patchForm() {
        console.log("CardImageInfoDetails=======>"+this.cardimageinfo)
        this.cardimageform.patchValue({
            card_id: this.cardimageinfo.card_id,
            x: this.cardimageinfo.x,
            height: this.cardimageinfo.height,
            y: this.cardimageinfo.y,
            width:this.cardimageinfo.width,
        })
    }   

    public loadScriptLibrary() {
        let body = <HTMLDivElement> document.body;
        let script = document.createElement('script');
        script.innerHTML = '';
        script.src = 'assets/adminlte/plugins/ckeditor/ckeditor.js';
        body.appendChild(script);

        let body2 = <HTMLDivElement> document.body;
        let script2 = document.createElement('script');
        script2.innerHTML = 'CKEDITOR.replace( \'tDescription\' );';
        body2.appendChild(script2);
    }
}



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/card_imagesmaster/addcard_images/addcard_images.component.ts